import routes from "@/constants/routes";
import { LandingNavLink } from "./types";

export const KlinkItems: LandingNavLink[] = [
  { caption: "Home buying guides", href: routes.guides },
  { caption: "How it works", href: routes.howItWorks },
  { caption: "FAQs", href: routes.faqs },
];
